__turbopack_context__.v({
  "button": "ItemMenu-module-scss-module__LlA_sa__button",
  "buttonIcon": "ItemMenu-module-scss-module__LlA_sa__buttonIcon",
  "item": "ItemMenu-module-scss-module__LlA_sa__item",
  "itemSub": "ItemMenu-module-scss-module__LlA_sa__itemSub",
  "popup": "ItemMenu-module-scss-module__LlA_sa__popup",
  "positioner": "ItemMenu-module-scss-module__LlA_sa__positioner",
});
